import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { Gift } from '../components/gift';
import { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import { Contacts } from '../components/contacts';

export default class WorkshopsPage extends React.Component {
  render() {
    const { data } = this.props;
    const { edges } = data.allMarkdownRemark;
    const {
      html,
      frontmatter: { title, subtitle },
    } = data.markdownRemark;

    return (
      <Layout title={title}>
        <section className="section">
          <div className="container">
            <h1 className="title is-1 has-text-centered">{title}</h1>
            <h3 className="title is-3 has-text-centered">{subtitle}</h3>
            <div className="columns is-multiline">
              {edges.map(({ node }) => (
                <div className="column is-one-quarter" key={node.id}>
                  <Gift
                    title={node.frontmatter.title}
                    description={node.frontmatter.description}
                    image={node.frontmatter.image}
                    slug={node.fields.slug}
                  />
                </div>
              ))}
            </div>
            <HTMLContent className="content" content={html} />
            <hr />
            <h4 className="title is-4">
              Для записи на мастер-класс или организации своего мероприятия, оставь свои контакты
              или свяжись со мной любым удобным способом.
            </h4>
            <div className="columns">
              <div className="column">
                <Contacts />
              </div>
              <div className="column">
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

WorkshopsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export const workshopsPageQuery = graphql`
  query WorkshopsQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        subtitle
      }
    }

    allMarkdownRemark(filter: { frontmatter: { type: { eq: "workshop" } } }) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            description
            image {
              childImageSharp {
                fluid(maxWidth: 400, maxHeight: 300, quality: 65) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`;
